import { useEffect, useState } from "react";
import { Container } from "react-grid-system";

import { Alert, Link as DSLink } from "@icg360/design-system";

import { usePolicyDetail } from "data/ss-data-hooks";
import { acceptPaymentOnCancelledPolicy, useFlags } from "utils";

import styles from "./cancellation-payment-notice.module.scss";

const CancellationPaymentNotice = () => {
  const { data } = usePolicyDetail();
  const [showCancellationPaymentNotice, setShowPaymentCancellationNotice] =
    useState(false);
  const [minimumPaymentMet, setMinimumPaymentMet] = useState(false);
  const { supportPhoneNumber } = useFlags();

  useEffect(() => {
    if (data?.userBilling && data?.userDetails && data?.userTransactions) {
      setMinimumPaymentMet(
        Number(data.userBilling.accounting?.minimumPaymentDue) === 0 &&
          data?.userTransactions?.transactions?.at(-1)?.type !== "CANCEL",
      );

      setShowPaymentCancellationNotice(
        acceptPaymentOnCancelledPolicy(
          data.userDetails.policyStatus,
          data.userDetails.policyStateAttributes?.reasonCode?.value,
          data.userDetails.currentTerm?.effectiveDatePolicyTerm,
          1, // Show notice even if they have made payment
          data.userPolicyProperties.moratorium?.isUnderMoratorium,
        ),
      );
    }
  }, [
    data?.userBilling,
    data?.userDetails,
    data?.userPolicyProperties.moratorium?.isUnderMoratorium,
    data?.userTransactions,
  ]);

  const policyExpiredNotice = (
    <>
      This policy has expired. To accept the renewal policy offer that was sent
      to you, please make a payment now. After receipt of payment, your policy
      will be activated within one business day. If you have questions, please
      contact your insurance representative or SageSure Customer Care at{" "}
      <DSLink href={`tel:${String(supportPhoneNumber)}`}>
        {String(supportPhoneNumber)}
      </DSLink>{" "}
      or{" "}
      <DSLink href="mailto:customercare@sagesure.com">
        customercare@sagesure.com
      </DSLink>
      .
    </>
  );
  const policyStatusUpdate = (
    <>
      Thank you for your payment. Your policy will be reactivated within one
      business day. If you have questions, please contact your insurance
      representative or SageSure Customer Care at at{" "}
      <DSLink href={`tel:${String(supportPhoneNumber)}`}>
        {String(supportPhoneNumber)}
      </DSLink>{" "}
      or{" "}
      <DSLink href="mailto:customercare@sagesure.com">
        customercare@sagesure.com
      </DSLink>
      .
    </>
  );

  return showCancellationPaymentNotice ? (
    <Container>
      <Alert
        appearance={minimumPaymentMet ? "success" : "danger"}
        className={styles.alert}
        title=""
        description={
          minimumPaymentMet ? policyStatusUpdate : policyExpiredNotice
        }
      />
    </Container>
  ) : null;
};

export default CancellationPaymentNotice;
